import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex vh-100 align-items-center justify-content-center" }
const _hoisted_2 = {
  class: "card shadow p-4",
  style: {"width":"350px"}
}
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = { class: "mb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bs5_base_label = _resolveComponent("bs5-base-label")!
  const _component_bs5_base_input = _resolveComponent("bs5-base-input")!
  const _component_bs5_base_button = _resolveComponent("bs5-base-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[6] || (_cache[6] = _createElementVNode("h3", { class: "text-center mb-3" }, "Login", -1)),
        _createElementVNode("form", {
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_bs5_base_label, { for: "email" }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode("Email address")
              ])),
              _: 1
            }),
            _createVNode(_component_bs5_base_input, {
              type: "email",
              modelValue: _ctx.model.login,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.login) = $event)),
              id: "email",
              placeholder: "Enter your email",
              required: ""
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_bs5_base_label, { for: "password" }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createTextVNode("Password")
              ])),
              _: 1
            }),
            _createVNode(_component_bs5_base_input, {
              type: "password",
              modelValue: _ctx.model.password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.password) = $event)),
              id: "password",
              placeholder: "Enter your password",
              required: ""
            }, null, 8, ["modelValue"])
          ]),
          _createVNode(_component_bs5_base_button, {
            variant: "primary",
            type: "submit",
            class: "w-100"
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createTextVNode("Sign in")
            ])),
            _: 1
          })
        ], 32),
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "text-center mt-3" }, [
          _createElementVNode("a", {
            href: "#",
            class: "text-decoration-none"
          }, "Don't have an account? Sign up")
        ], -1))
      ])
    ])
  ]))
}